import { API } from '@/shared/api';
import DownloadImage from '@/shared/assets/images/feature-paywall/download-visual.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent } from '../types';

export const DOWNLOAD_CONTENT: LimitedFeatureContent = {
  trial: {
    title: '',
    bulletsHeader: '',
    buttonText: '',
    checkIsSpaceOwner: false,
    features: [],
    media: { src: DownloadImage, type: 'image' },
    mixpanelButtonClickEvent: () => MixpanelEvents.viewPlanPaywallClick(),
    mixpanelOpeningEvent: () => {
      MixpanelEvents.paywallOpened();
      void API.sendActivitySignal('paywall_opened');
    },
    subtitle: '',
  },
};
